import GoalIcon from '@/components/goals/GoalIcon';
import {
    OverlappingAvatars,
    SingleAvatar,
} from '@/components/users/UserAvatars';
import { Box, FlexProps, Tooltip } from '@chakra-ui/react';
import { CashflowFinancialEntity } from '@common/react/cashflow';

interface InstitutionLogoProps extends FlexProps {
    financialEntity: Pick<
        CashflowFinancialEntity,
        'goal' | 'name' | 'institutionLogo'
    >;
    size?: number;
    showTooltip?: boolean;
    avatarBadge?: AvatarBadgeProps | undefined;
}

export interface AvatarBadgeProps {
    isVisible: boolean;
    isJoint: boolean;
    isMine: boolean;
}

const InstitutionLogo = ({
    financialEntity,
    size = 6,
    showTooltip = false,
    avatarBadge = { isVisible: false, isJoint: false, isMine: true },
    ...props
}: InstitutionLogoProps) => {
    if (!financialEntity.institutionLogo && !financialEntity.goal) {
        return null;
    }

    return (
        <>
            <Tooltip label={showTooltip && financialEntity.name}>
                {financialEntity.goal ? (
                    <GoalIcon goal={financialEntity.goal} {...props} />
                ) : (
                    <Box
                        minW={size}
                        w={size}
                        h={size}
                        borderRadius="full"
                        bg={`url('${financialEntity.institutionLogo}') 50% 50%/cover no-repeat`}
                        {...props}
                    />
                )}
            </Tooltip>
            {avatarBadge &&
                avatarBadge.isVisible &&
                (avatarBadge.isJoint ? (
                    <OverlappingAvatars
                        userAvatarLeft={-2}
                        size="2xs"
                        mx={5}
                        my={-3}
                    />
                ) : (
                    <SingleAvatar
                        isPartner={!avatarBadge.isMine}
                        size="2xs"
                        mx={3}
                        my={-3}
                    />
                ))}
        </>
    );
};

export default InstitutionLogo;
